import {get} from 'svelte/store';
import {isUtaSpot$, unifiedAccountUpgradedTime$} from '@/streams/uta-state';
import {openPage} from '@/modules/assets/components/action-util';
import {fixLink$} from '@/store';
import {PATHS} from '@/const';

type ConvertFun = (query: Record<string, any>, unifiedAccountUpgradedTime: number) => Record<string, any>;

export function formatterUpgradedBeforeAfter(utaState, query, convertBefore?: ConvertFun, convertAfter?: ConvertFun) {
  const isUtaSpot = isUtaSpot$.getValue();

  if (!isUtaSpot || (!convertBefore && !convertAfter)) {
    return query;
  }

  const unifiedAccountUpgradedTime = unifiedAccountUpgradedTime$.getValue();
  if (utaState === 1) {
    return convertAfter ? convertAfter(query, unifiedAccountUpgradedTime) : query;
  } else {
    return convertBefore ? convertBefore(query, unifiedAccountUpgradedTime) : query;
  }
}

export enum FundsTab {
  TradingAccountDetail = 'TradingAccountDetail',
  FundSpotAccount = 'FundSpotAccount',
  FundAccountFund = 'FundAccountFund',
  FundAccountFiat = 'FundAccountFiat',
  FundMarginAccount = 'FundMarginAccount',
  FundAccountInvestment = 'FundAccountInvestment',
  ContractAccountDetail = 'ContractAccountDetail',
  PilotContractAccountDetail = 'PilotContractAccountDetail',
}

export enum FundsTabValue {
  FundSpotAccount = 1,
  ContractAccountDetail = 2,
  FundAccountInvestment = 3,
  FundMarginAccount = 4,
  FundAccountFiat = 5,
  FundLendingAccount = 6,
  PilotContractAccountDetail = 8,
}

export function goHistory(type: string, filterType?: string) {
  openPage(get(fixLink$)(PATHS.ASSETS_FUNDS.pathname) + `?type=${type}` + (filterType ? `&filterType=${filterType}` : ''));
}
